import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GameStatus } from '../../models/GameStatus';

interface GameListState {
    gameList: GameListItemState[],
    admins: string[],
}

interface GameListItemState {
    gameId: string;
    gameStarted: Boolean;
    playerList: {
        playerId: string,
        username: string,
        isHost: boolean,
    }[];
    status: GameStatus;
    turnNumber: number;
    gameAdmins: string[];
}

const initialState: GameListState = {
    gameList: [],
    admins: []
}

const gameListSlice = createSlice({
    name: 'gameList',
    initialState,
    reducers: {
        receiveGames: ((state, action: PayloadAction<any>) => {
            if (action.payload.gameList !== undefined && action.payload.gameList !== null) {
                state.gameList = [...action.payload.gameList];
            }
            if (action.payload.admins !== undefined && action.payload.admins !== null) {
                state.admins = [...action.payload.admins]
            }
        }),
    }
});

export const gameListActions = gameListSlice.actions;
export default gameListSlice.reducer;